(ns manage.ad-variant.page.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Fade$default" :as Fade]
            ["@mui/material/ListItemIcon$default" :as ListItemIcon]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/MenuList$default" :as MenuList]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Popper$default" :as Popper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium useGridApiRef]]
            ["moment/min/moment-with-locales$default" :as moment]
            ["src/svg/artwork/table.svg$default" :as TableArtwork]
            ["src/svg/controls/watch.svg$default" :as Watch]
            ["src/svg/divider/vertical-components.svg$default" :as VerticalDivider]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            ["src/svg/inform/plus.svg$default" :as PlusIcon]
            ["src/svg/objects/3d-cube.svg$default" :as ThreeDCube]
            ["src/svg/wpp/arrows/chevron-right.svg$default" :as ChevronRight]
            ["src/svg/wpp/content-actions/approval.svg$default" :as ApprovalIcon]
            ["src/svg/wpp/content-actions/download.svg$default" :as DownloadIcon]
            ["src/svg/wpp/content-actions/edit.svg$default" :as Edit]
            ["src/svg/wpp/content-actions/forward.svg$default" :as ForwardIcon]
            ["src/svg/wpp/content/calendar.svg$default" :as Calendar]
            ["src/svg/wpp/content/stack.svg$default" :as StackIcon]
            [assemble.util :refer [file-extension]]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.set :as set]
            [clojure.string :as str]
            [common.db.effects.binary :refer [download zip!]]
            [common.flags :refer [use-flag]]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.social-settings :refer [use-auto-publish]]
            [common.resource.query.user :as user-queries]
            [common.uix.hooks :as uix.hooks]
            [common.url-template :as url-tpl]
            [common.util :refer [spread-obj]]
            [common.widgets.data-grid :as dg]
            [common.widgets.page :as page]
            [linked.core :as l]
            [manage.ad-variant-insights.view :refer [insights-tab]]
            [manage.ad-variant-preview.view :refer [ad-variant-preview-page]]
            [manage.ad-variant.approval.modal]
            [manage.ad-variant.archive-confirmation-modals
             :refer [use-open-archivation-confirm-modal]]
            [manage.ad-variant.creation.core.view :refer [ad-variant-creation-page]]
            [manage.ad-variant.creation.entry-ocp.view :as entry]
            [manage.ad-variant.creation.link.hooks :as link-hooks]
            [manage.ad-variant.creation.link.link-ad-variants-ocp]
            [manage.ad-variant.creation.manual-upload-ocp.hooks :as manual-upload.h]
            [manage.ad-variant.creation.manual-upload-ocp.view]
            [manage.ad-variant.data :as variant-data]
            [manage.ad-variant.details-ocp.core :as details-ocp]
            [manage.ad-variant.drawer.view :refer [variant-drawer]]
            [manage.ad-variant.hooks :as h]
            [manage.ad-variant.page.columns :as columns]
            [manage.ad-variant.page.db :as db]
            [manage.ad-variant.page.table-util :refer [ad-variant-table-filters]]
            [manage.ad-variant.queries :as q]
            [manage.ad-variant.review.hooks :refer [use-users-doing-qc-reviews]]
            [manage.ad-variant.schedule-modal]
            [manage.adset-decision-tree-page.view.context :as decision-tree-context]
            [manage.adset-decision-tree-page.view.core :refer [strategy-view]]
            [manage.adset-decision-tree-page.view.header :as dt-header]
            [manage.adset.hooks :refer [use-adset use-auto-approved? use-synced-with-hogarth?] :as adset.h]
            [manage.adset.view.page-header :as adset-page-header]
            [manage.campaign-tags-page.view :refer [campaign-tags-page
                                                    use-campaign-tags-page-props]]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal stop-rendering-confirm :ad-variant/stop-rendering-confirm
  []
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        {render-again :mutate}
        (use-mutation (q/render-again-mutation {:advertiser-id advertiser-id
                                                :adset-id adset-id}))]
    ($ modal-v2
       {:title "Stop rendering"
        :icon ($ SvgIcon {:color "warning"}
                 ($ AlertIcon))
        :footer ($ Stack {:direction "row" :gap 1}
                   ($ Button {:variant "text"
                              :sx #js {:color "text.primary"}
                              :onClick (fn [_e] (rf/dispatch [:modal/close]))}
                      "Cancel")
                   ($ Button {:variant "contained"
                              :color "warning"
                              :onClick (fn [_e]
                                         (render-again {:cancel true
                                                        :all true}
                                                       #js {:onSuccess (fn [_]
                                                                         (rf/dispatch [:modal/close]))}))}
                      "Yes, stop"))}
       ($ :p "Are you sure you want to stop rendering ads in progress? You can manually re-start later."))))

(defui rendering-in-progress-box [{:keys [counts]}]
  ($ Alert
     {:severity "info"
      :icon ($ ThreeDCube)
      :sx #js {:backgroundColor "grey.90"
               ;; Allow absolute position for the progress bar
               :position "relative"
               ;; Make the progress child obey the parent borderRadius.
               ;; Progress bottom border and end wouldn't work correctly
               ;; with border radius on the progress element directly.
               :overflow "hidden"
               :flexShrink 0
               ;; Allow positioning the stop button with flexbox
               ".MuiAlert-message" #js {:display "flex"
                                        :flexGrow 1
                                        :flexDirection "row"
                                        ;; Ensure the contents are above the progress bar background
                                        :zIndex 10}
               ;; Progress bar element
               "&:before" #js {:content "\"\""
                               :position "absolute"
                               :top 0
                               :left 0
                               :bottom 0
                               :width (str (:progress counts) "%")
                               :backgroundColor "primary.selected"
                               :borderBottomWidth "4px"
                               :borderBottomColor "primary.400"
                               :borderBottomStyle "solid"}}}
     ($ Stack
        {:direction "column"}
        ($ AlertTitle
           "Rendering ad variants")
        ($ Stack
           {:direction "row"}
           (:done counts) " of " (:total counts) " rendered "
           (when (pos? (:render-failed counts))
             ($ :<>
                ($ SvgIcon
                   {:component VerticalDivider
                    :viewBox "0 0 19 20"})
                ($ Typography
                   (:render-failed counts) " failed")))))
     ($ Box
        {:flexGrow 1})
     ($ Stack
        ($ Button
           {:variant "text"
            :color "secondary"
            :sx #js {:textDecoration "none"}
            :onClick (fn [_e]
                       (rf/dispatch [:modal/open {:id :ad-variant/stop-rendering-confirm}]))}
           "Stop"))))

(defui render-failed-box [{:keys [counts rows render-again]}]
  (let [[filter-model set-filter-model] (dg/use-filter-model)]
    ($ Alert
       {:severity "warning"
        :icon ($ ThreeDCube)}
       ($ AlertTitle
          ;; Consider canceled also failed
          (+ (:render-failed counts 0)
             (:canceled counts 0))
          " Ad variants failed to render")
       ($ Stack
          {:direction "row"}
          ($ Button
             {:variant "contained"
              :color "warning"
              :onClick (fn [_e]
                         (let [model (-> (->clj filter-model)
                                         ;; Remove status filter
                                         (dg/remove-field "status"))]
                           (set-filter-model (->js model)))
                         (let [failed-uuids (->> rows
                                                 (filter #(#{"render-failed"} (:ad-variant-status %)))
                                                 (mapv :uuid))]
                           (render-again {:ad-uuids failed-uuids})))}
             "Try render again")

          ($ SvgIcon
             {:component VerticalDivider
              :viewBox "0 0 19 20"
              :sx #js {:alignSelf "center"
                       :mx 0}})
          ($ Button
             {:variant "contained"
              :color "primary"
              :onClick (fn [_e]
                         (let [model (-> (->clj filter-model)
                                         ;; Remove status filter, so it isn't added twice
                                         (dg/remove-field "status")
                                         (update :items (fnil conj [])
                                                 {:id "status"
                                                  :field "status"
                                                  :operator "is-any-of"
                                                  :value ["render-failed"]}))]
                           (set-filter-model (->js model))))}
             "Show all failed")))))

(defn count-states [rows]
  (let [counts (reduce (fn [acc row]
                         (let [status (keyword (:ad-variant-status row))]
                           (update acc status (fnil inc 0))))
                       {:total (count rows)}
                       rows)
        pending (+ (:queued counts)
                   (:rendering counts)
                   ;; Is failed considered done or not?
                   ;; (:render-failed state->count)
                   (:canceled counts))
        done (- (:total counts)
                pending)
        progress (* 100 (/ done (:total counts)))]
    (assoc counts
           :pending pending
           :done done
           :progress progress)))

(defn is-adset-under-review [under-review]
  ;; We're checking for the id here, because the backend returns a bit of a silly response
  ;; when there's no review for the adset. This should be fixed.
  (boolean (:request/id under-review)))

(defui ad-variant-approval-submenu [{:keys [selection selected-rows on-selection-model-change]}]
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        [open set-open] (uix/use-state false)
        anchor-ref (uix/use-ref)
        hover-timeout (uix/use-ref)

        handle-mouse-enter (fn []
                             (some-> @hover-timeout js/clearTimeout)
                             (set-open true))

        handle-mouse-leave (fn []
                             (reset! hover-timeout (js/setTimeout #(set-open false) 100)))

        {set-approval :mutate}
        (use-mutation (q/set-approval-mutation {:advertiser-id advertiser-id
                                                :adset-id adset-id}))

        {archive-fn :mutate}
        (use-mutation (q/archive-mutation {:advertiser-id advertiser-id
                                           :adset-id adset-id}))

        {unarchive-fn :mutate}
        (use-mutation (q/unarchive-mutation {:advertiser-id advertiser-id
                                             :adset-id adset-id}))

        {review :data} (use-query (q/review-query {:adset-id adset-id}))
        is-under-review? (is-adset-under-review review)

        available-actions (uix/use-memo
                           (fn []
                             (->> selected-rows
                                  (map (comp variant-data/status->actions
                                             :ad-variant-status))
                                  (apply set/union)))
                           [selected-rows])

        {{published-decision-tree-id :id} :published
         {draft-decision-tree-id :id} :draft}
        (uix/use-context decision-tree-context/decision-trees-context)
        ready-and-update-disabled (not (or published-decision-tree-id draft-decision-tree-id))
        auto-approved? (use-auto-approved?)
        auto-publish? (use-auto-publish)
        synced-with-hogarth? (use-synced-with-hogarth?)
        open-archive-confirm (use-open-archivation-confirm-modal)]
    ($ :<>
       ($ MenuItem
          {:ref anchor-ref
           :onMouseEnter handle-mouse-enter
           :onMouseLeave handle-mouse-leave
           :onClick (fn [e]
                      (.stopPropagation e))}
          ($ ListItemIcon ($ SvgIcon {:component ForwardIcon
                                      :inheritViewBox true}))
          "Change status to"
          ($ ListItemIcon ($ SvgIcon {:component ChevronRight
                                      :inheritViewBox true})))
       ($ Popper
          {:anchorEl @anchor-ref
           :open open
           :placement "right-start"
           :sx #js {:zIndex 1400
                    :top "-8px !important"}}
          ($ Paper
             {:elevation 2
              :onMouseEnter handle-mouse-enter
              :onMouseLeave handle-mouse-leave}
             ($ MenuList
                (when-not auto-approved?
                  ($ MenuItem
                     {:onClick (fn [_e]
                                 (set-approval {:approval "approved"
                                                :uuids selection}
                                               #js {:onSuccess (fn [_response _variables _context]
                                                                 ;; Reset selection after bulk action completes
                                                                 (when on-selection-model-change
                                                                   (on-selection-model-change #js [])))}))
                      :disabled (not (contains? available-actions :approve))}
                     "Ready"))
                (when-not (or auto-approved? auto-publish?)
                  ($ Tooltip
                     {:title "There is no decision tree yet"
                      :disableHoverListener (not ready-and-update-disabled)}
                     ($ MenuItem
                        {:disabled (or ready-and-update-disabled
                                       (not (contains? available-actions :ready-and-update-dt)))
                         :onClick (fn [_e]
                                    (set-approval {:approval "ready-and-update-dt"
                                                   :uuids selection}))}
                        "Ready and Update Decision Tree")))
                (when (or synced-with-hogarth? (not auto-approved?))
                  ($ Tooltip
                     {:title "There is no active approval request"
                      :disableHoverListener is-under-review?}
                     ($ :div
                        ($ MenuItem
                           {:onClick (fn [_e]
                                       (set-approval {:approval "internal-review"
                                                      :uuids selection}
                                                     #js {:onSuccess (fn [_response _variables _context]
                                                                       ;; Reset selection after bulk action completes
                                                                       (when on-selection-model-change
                                                                         (on-selection-model-change #js [])))}))
                            :disabled (or (not is-under-review?)
                                          (not (contains? available-actions :internal-review)))}
                           "Internal review")))
                  (when-not synced-with-hogarth?
                    ($ Divider {:sx #js {:my 1}})))
                ($ MenuItem
                   {:onClick (fn [_e]
                               (let [do-archive (fn [on-success]
                                                  (archive-fn {:uuids selection
                                                               :on-success (fn []
                                                                             (when on-success (on-success))
                                                                             (when on-selection-model-change
                                                                               (on-selection-model-change #js [])))}))]
                                 (if (some :assigned selected-rows)
                                   (open-archive-confirm {:on-confirm do-archive
                                                          :bulk true})
                                   (do-archive nil))))
                    :disabled (not (contains? available-actions :archive))}
                   "Archive")
                ($ MenuItem
                   {:onClick (fn [_e]
                               (unarchive-fn {:uuids selection
                                              :on-success (fn []
                                                            (when on-selection-model-change
                                                              (on-selection-model-change #js [])))}))
                    :disabled (not (contains? available-actions :unarchive))}
                   "Unarchive")))))))

(defn- ->user-options [^js data]
  (->> (->clj data)
       (map (fn [{:keys [email name id]}]
              {:id id
               :label name
               :value email
               :status :active}))))

(defui approval-request-button [{:keys [is-video? selected-rows]}]
  (let [{:keys [agency-id]} (use-subscribe [:url-context])
        {users :data} (use-query (spread-obj (user-queries/users-query {:agency-id agency-id})
                                             #js {:select ->user-options}))
        {me :data} (use-query (user-queries/user-query))
        review-creator (use-subscribe [:manage.ad-variant.approval.db/review-creator])

        available-users (uix/use-memo (fn []
                                        (->> users
                                             (remove #(or (= (:id %) (:id me))
                                                          (= (:id %) review-creator)))
                                             to-array))
                                      [users me review-creator])

        ad-variants-rendered? (uix/use-memo
                               (fn []
                                 (some (fn [{:keys [components ad-type]}]
                                         (:value (variant-data/get-main-component components ad-type)))
                                       selected-rows))
                               [selected-rows])

        enable-approval-request (if is-video?
                                  ad-variants-rendered?
                                  (boolean (seq selected-rows)))]
    ($ MenuItem
       {:disabled (not enable-approval-request)
        :onClick #(rf/dispatch (if (seq users)
                                 [:modal/open {:id :ad-variant/approval
                                               :props {:users available-users}}]
                                 [:modal/open {:id :ad-variant/no-user-access}]))}
       ($ ListItemIcon ($ SvgIcon {:component ApprovalIcon
                                   :inheritViewBox true}))
       "Approval request")))

(defui download-ads-button [{:keys [adset-name selected-rows]}]
  (let [[downloading set-downloading] (uix/use-state false)
        artificats-for-selection
        (->> selected-rows
             (keep (fn [{:keys [content-id dimensions ad-type components revision]}]
                     (let [component-type (variant-data/get-component-type ad-type)]
                       (when (contains? #{:video :image} component-type)
                         (when-let [file-url (:value (variant-data/get-main-component components ad-type))]
                           (let [file-name (->> [content-id
                                                 ad-type
                                                 (str (:width dimensions) "x" (:height dimensions))
                                                 (when (= :video component-type)
                                                   (str (:duration dimensions) "s"))
                                                 (str "v" revision)]
                                                (remove nil?)
                                                (str/join "_"))]
                             {:name (str file-name "." (file-extension file-url))
                              :url file-url})))))))]
    (when (seq artificats-for-selection)
      ($ MenuItem
         {:disabled downloading
          :onClick (fn []
                     (let [timestamp (-> (moment) (.format "YYYY-MM-DD_HH-mm"))
                           zip-name (str adset-name " creative assets " timestamp)]
                       (set-downloading true)
                       (zip! artificats-for-selection
                             {:on-success (fn [zip-blob]
                                            (download zip-blob zip-name)
                                            (set-downloading false)
                                            (rf/dispatch
                                             [:toaster-bus/add {:id ::zip-download-success
                                                                :type :success
                                                                :message "Finished downloading ads."}]))
                              :on-failure (fn [err]
                                            (set-downloading false)
                                            (rf/dispatch
                                             [:toaster-bus/add {:id ::zip-download-failure
                                                                :type :error
                                                                :message "Something went wrong while downloading ads."
                                                                :full-message err}]))})))}
         ($ ListItemIcon ($ SvgIcon {:component DownloadIcon
                                     :inheritViewBox true}))
         "Download ads"))))

(defui ad-variant-bulk-actions-menu
  [{:keys [selection on-selection-model-change rows is-video? adset-name]}]
  (let [[anchor-el set-anchor-el] (uix/use-state nil)
        handle-click #(set-anchor-el (.. % -currentTarget))
        handle-close #(set-anchor-el nil)

        selected-rows (uix/use-memo
                       (fn []
                         (->> (->clj rows)
                              (filter (fn [row]
                                        (contains? selection (:uuid row))))))
                       [rows selection])

        artifacts-download-enabled? (use-flag :ad-variant-artifacts-download)
        ad-variant-scheduling-enabled? (use-flag :ad-variant-scheduling)]
    ($ :<>
       ($ Button
          {:onClick handle-click
           :data-testid "account-button"
           :startIcon ($ StackIcon)}
          "Bulk actions")
       ($ Menu
          {:anchorEl anchor-el
           :open (some? anchor-el)
           :onClose handle-close
           :onClick handle-close}
          ($ ad-variant-approval-submenu
             {:selection selection
              :selected-rows selected-rows
              :on-selection-model-change on-selection-model-change})
          ($ approval-request-button
             {:is-video? is-video?
              :selected-rows selected-rows})
          (when (and ad-variant-scheduling-enabled? (not-any? :feed-id selected-rows))
            ($ MenuItem
               {:onClick #(when (seq selected-rows)
                            (rf/dispatch [:modal/open {:id :ad-variants/schedule-modal
                                                       :props {:ad-variants selected-rows}}]))}
               ($ ListItemIcon ($ SvgIcon {:component Calendar
                                           :inheritViewBox true}))
               "Schedule ads"))
          (when artifacts-download-enabled?
            ($ download-ads-button
               {:adset-name adset-name
                :selected-rows selected-rows}))))))

(defui ad-variant-management-menu [{:keys [mapped-campaigns adset]}]
  (let [[anchor-el set-anchor-el] (uix/use-state nil)
        handle-click #(set-anchor-el (.. % -currentTarget))
        handle-close #(set-anchor-el nil)
        url-context (use-subscribe [:url-context])
        ad-variant-manual-upload-enabled? (manual-upload.h/use-manual-upload-enabled? adset)
        synced-with-hogarth? (use-synced-with-hogarth?)]
    ($ :<>
       ($ Button
          {:onClick handle-click
           :data-testid "account-button"
           :startIcon ($ Edit)}
          "Manage ad variants")
       ($ Menu
          {:anchorEl anchor-el
           :open (some? anchor-el)
           :onClose handle-close
           :onClick handle-close}
          (when (or synced-with-hogarth? (seq mapped-campaigns))
            ($ MenuItem
               {:onClick #(rf/dispatch [:ocp/open {:id :ad-variants-link-ocp}])}
               "Manage Assemble connections"))
          (when ad-variant-manual-upload-enabled?
            ($ MenuItem
               {:onClick #(rf/dispatch [:modal/open {:id :ad-variants/manual-upload-modal}])}
               "Upload new ads"))
          ($ MenuItem
             {:component "a"
              :href (rfe/href :adset/ad-variants-creation url-context)}
             "Open dynamic ad builder")))))

(def Toolbar
  (uix/as-react
   (fn [{:keys [rows creating-ad-variants? selection on-selection-model-change adset]}]
     (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
           is-video? (not= (:channel adset) "display")

           {:keys [mapped-campaigns]} (link-hooks/use-ps-campaigns)

           counts (uix/use-memo (fn [] (count-states rows)) [rows])

           {render-again :mutate}
           (use-mutation (q/render-again-mutation {:advertiser-id advertiser-id
                                                   :adset-id adset-id}))]
       ($ :<>
          ($ dg/grid-toolbar
             ($ ad-variant-table-filters)

             (when (seq selection)
               ($ ad-variant-bulk-actions-menu
                  {:selection selection
                   :on-selection-model-change on-selection-model-change
                   :is-video? is-video?
                   :adset-name (:name adset)
                   :rows rows}))

             ($ Button
                {:variant "text"
                 :disabled (empty? rows)
                 :onClick #(rf/dispatch [:manage.ad-variant-preview.db/open-preview selection false])
                 :startIcon ($ Watch)}
                "Preview"
                (when (seq selection)
                  ($ Typography
                     {:fontWeight "400"
                      :sx #js {:ml 1}}
                     (variant-data/selection-count selection))))

             ($ ad-variant-management-menu
                {:mapped-campaigns mapped-campaigns
                 :adset adset}))

          (if creating-ad-variants?
            ($ Alert
               {:severity "info"}
               ($ AlertTitle "Loading ad variants")
               "Loading your ad variants. This should only take a few moments.")
            (when is-video?
              (cond
                (or (pos? (:queued counts))
                    (pos? (:rendering counts)))
                ($ rendering-in-progress-box
                   {:counts counts})

                (or (pos? (:render-failed counts))
                    (pos? (:canceled counts)))
                ($ render-failed-box
                   {:counts counts
                    :rows rows
                    :render-again render-again})))))))))

(defn- add-review-users-to-rows [rows users-doing-qc-reviews]
  (->> (mapv (fn [ad-variant]
               (let [users (mapv (fn [{:keys [statuses] :as user-mapping}]
                                   ;; There should only be a single status per user, per ad-variant, so using first here should be fine
                                   (if-let [ad-variant-review-status (first (filter #(= (:status/subject-id %) (:uuid ad-variant)) statuses))]
                                     (assoc user-mapping :status/status (:status/status ad-variant-review-status))
                                     user-mapping)) users-doing-qc-reviews)]
                 (assoc ad-variant :review-users users))) rows)
       (to-array)))

(defui table [{:keys [^js api-ref creating-ad-variants?]}]
  (let [{:keys [adset-id] :as url-context} (use-subscribe [:url-context])
        create-lift-enabled (use-flag :create-lift-preview)
        adset (use-adset)
        manual-upload-enabled? (manual-upload.h/use-manual-upload-enabled? adset)
        {under-review :data} (use-query (q/review-query {:adset-id adset-id}))
        users-doing-qc-reviews (use-users-doing-qc-reviews)
        [selection-model set-selection-model] (uix/use-state #js [])
        [selection set-selection] (uix.hooks/use-state {:initial-value #{}
                                                        :path [::db/state :selection]})

        initial-pagination-model #js {:page 0 :pageSize 10}

        table-query-fn (uix/use-callback
                        (fn [table-models]
                          (q/ad-variants-by-content-id-query
                           (assoc url-context :refetch true)
                           {:field->sort-field columns/field->sort-field
                            :field->column columns/field->column
                            :field->resolver columns/field->resolver
                            :quick-filter {:field (columns/field->column
                                                   (.-field columns/identifier-column))}}
                           table-models))
                        [url-context columns/field->sort-field])

        row-grouping-props (h/use-ad-variant-grouping-props
                            {:api-ref api-ref
                             :groups-opened-by-default true
                             :initial-column-visibility-model {:width false
                                                               :height false}})

        {:keys [rows onFilterModelChange] :as server-table-props}
        (dg/use-server-table-props
         {:row-grouping-model (:rowGroupingModel row-grouping-props)
          :initial-pagination-model initial-pagination-model
          :table-query-fn table-query-fn
          :prevent-loading-on-refetch true
          :initial-filter-model
          (->js {:items [{:id "status"
                          :field "status"
                          :operator "isAnyOf"
                          :value (->> variant-data/status
                                      (map key)
                                      (remove #{"archived"}))}]
                 :logicOperator "and"})})

        rows (uix/use-memo (fn []
                             (if (seq users-doing-qc-reviews)
                               (add-review-users-to-rows rows users-doing-qc-reviews)
                               rows))
                           [rows users-doing-qc-reviews])

        show-internal-review-column (uix/use-memo (fn []
                                                    (is-adset-under-review under-review))
                                                  [under-review])

        ad-variant-scheduling-enabled? (use-flag :ad-variant-scheduling)

        columns (uix/use-memo (fn []
                                (columns/basic-columns show-internal-review-column
                                                       (variant-data/has-product-selector? rows)
                                                       create-lift-enabled
                                                       manual-upload-enabled?
                                                       ad-variant-scheduling-enabled?))
                              [show-internal-review-column
                               rows
                               create-lift-enabled
                               manual-upload-enabled?
                               ad-variant-scheduling-enabled?])

        get-footer-row-selected-text (uix/use-callback
                                      (fn [_]
                                        (let [selection-count (count selection)]
                                          (condp < selection-count
                                            1 (str selection-count " rows selected")
                                            0 (str selection-count " row selected")
                                            "")))
                                      [selection])
        activation-details-side-panel-enabled (use-flag :activation-details-side-panel)
        on-row-click (uix/use-callback
                      (fn [^js o ^js _event]
                        (let [row (->clj (.-row o))]
                          (when (seq row)
                            (if activation-details-side-panel-enabled
                              (rfe/set-query #(assoc % :variant (:uuid row)))
                              (rf/dispatch [:manage.ad-variant.drawer.db/set-current-variant row])))))
                      [activation-details-side-panel-enabled])

        on-selection-model-change (uix/use-callback
                                   (fn [selection-model]
                                     (letfn [(is-autogenerated-row? [id]
                                               (some-> (.getRowNode (.-current api-ref) id)
                                                       (.-isAutoGenerated)))]
                                       (set-selection (-> selection-model
                                                          (.filter (complement is-autogenerated-row?))
                                                          set))
                                       (set-selection-model selection-model)))
                                   [api-ref])

        on-filter-model-change (uix/use-callback
                                (fn [filter-model]
                                  (set-selection #{})
                                  (set-selection-model #js [])
                                  (onFilterModelChange filter-model))
                                [onFilterModelChange])]
    (uix/use-effect
     (fn []
       ;; Timeout to wait for render. See: https://github.com/mui/mui-x/issues/10578
       (when (and api-ref (.-current api-ref) (pos? (count rows)))
         (let [timeout (js/setTimeout
                        (fn []
                          (.autosizeColumns (.-current api-ref)))
                        200)]
           #(js/clearTimeout timeout))))
     [api-ref rows])
    (uix/use-effect (fn []
                      ;; reset selection on unmount
                      #(set-selection #{}))
                    [])
    (details-ocp/use-ocp-state-from-query-params)
    ($ DataGridPremium
       (merge
        server-table-props
        row-grouping-props
        {:apiRef api-ref
         :columns columns
         :rows rows
         :getRowId (fn [row] (:uuid row))
         :onRowClick on-row-click

         ;; the sorting happens on client except for content id, so disable server mode
         :sortingMode nil
         :pageSizeOptions #js [10 20 50]
         :checkboxSelection true
         :disableRowSelectionOnClick true
         :disableColumnMenu true
         :rowSelectionPropagation #js {:parents true :descendants true}
         :rowSelectionModel selection-model
         :onRowSelectionModelChange on-selection-model-change
         :onFilterModelChange on-filter-model-change
         :slots #js {:toolbar Toolbar}
         :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                         :toolbar #js {:rows rows
                                       :creating-ad-variants? creating-ad-variants?
                                       :selection selection
                                       :on-selection-model-change on-selection-model-change
                                       :adset adset}}
         :localeText #js {:toolbarQuickFilterPlaceholder "Search in identifier..."
                          :footerRowSelected get-footer-row-selected-text}
         :noWrap true
         :sx #js {:pt 3
                  ".MuiDataGrid-actionsCell svg" #js {:opacity 0
                                                      :transition "opacity 100ms linear"}
                  "& .MuiDataGrid-row:hover .MuiDataGrid-actionsCell svg, & .Mui-selected .MuiDataGrid-actionsCell svg"
                  #js {:opacity 1}}}))))

(defui list-view [{:keys [isInitialLoading has-ad-variants? creating-ad-variants? grid-api-ref]}]
  (let [url-context (use-subscribe [:url-context])
        project-linking-available? (boolean (use-subscribe [:common.os/enabled]))
        {:keys [mapped-campaigns]} (link-hooks/use-ps-campaigns)
        already-linked? (and (use-synced-with-hogarth?) (seq mapped-campaigns))
        activation-details-side-panel-enabled (use-flag :activation-details-side-panel)]
    (cond
      isInitialLoading
      ($ Stack {:alignItems "center"
                :justifyContent "center"
                :sx #js {:flex 1}}
         ($ CircularProgress))

      (not has-ad-variants?)
      ($ empty-state-view
         {:title (if (and project-linking-available? already-linked?) "Ad variants unavailable" "Add ad variants")
          :description (if already-linked?
                         "Linked adsets don't have any ad variants yet. They'll appear here once published by the production tool."
                         "Ready to engage? Add and manage your ad variants for (dynamic) activation.
                          Upload or import ads for other production tools or build ad variants yourself
                          by combining a dynamic template with content.")
          :artwork TableArtwork
          :docs-href (when-not already-linked?
                       (url-tpl/render :docs/article (assoc url-context :slug "22087220842140-Understanding-Ad-Variants")))
          :actions (when-not already-linked?
                     ($ Button
                        {:variant "contained"
                         :onClick #(rf/dispatch [:ocp/open {:id ::entry/create-ad-variants-entry}])
                         :startIcon ($ PlusIcon)}
                        "Add ad variants"))})

      :else
      ($ Stack
         {:direction "row"
          :sx #js {:flex 1
                   :overflow "hidden"}}
         ($ table
            {:api-ref grid-api-ref
             :creating-ad-variants? creating-ad-variants?})
         (when-not activation-details-side-panel-enabled
           ($ variant-drawer
              {:grid-api-ref grid-api-ref}))))))

(defui ad-variant-tab []
  (let [url-context (use-subscribe [:url-context])
        {:keys [isInitialLoading data]} (h/use-trigger-ad-variant-refetch url-context)
        has-ad-variants? (some? (get-in data [:data :latest-ad-variants-updated-at]))
        creating-ad-variants? (= "in progress" (get-in data [:data :ad-variant-creation-status]))
        grid-api-ref (useGridApiRef)]
    ($ list-view
       {:isInitialLoading isInitialLoading
        :has-ad-variants? has-ad-variants?
        :creating-ad-variants? creating-ad-variants?
        :grid-api-ref grid-api-ref})))

(defui decision-tree-tab []
  ($ Stack
     {:sx #js {:pt 3
               :minHeight 0
               :flex 1}}
     ($ strategy-view)))

(def tabs
  (l/map :ad-variants
         {:label "Ad variants"
          :container-sx #js {:overflow "hidden"}
          :view ad-variant-tab}

         :strategy
         {:label "Strategy"
          :container-sx #js {:overflow "hidden"}
          :view decision-tree-tab}

         :insights
         {:label "Insights"
          :view insights-tab}))

(defn close-preview [] (rfe/set-query #(dissoc % :ad-variants-preview :review)))

(defui ad-variant-page []
  (let [view (use-subscribe [:router/handler-name])
        {:keys [ad-variants-preview]} (use-subscribe [:router/query-parameters])
        {:keys [adset-id]} (use-subscribe [:url-context])
        creation (= :adset/ad-variants-creation view)
        insights-enabled (use-flag :adset-insights)]
    (uix/use-effect (fn []
                      (rf/dispatch [:manage.ad-variant.approval.db/get-review adset-id]))
                    [adset-id])
    ($ decision-tree-context/with-decision-tree-context
       ($ page/page
          ($ adset-page-header/page-header
             {:tabs (cond-> tabs
                      (not insights-enabled)
                      (dissoc :insights))}
             ($ dt-header/automation-paused-alert))
          ($ page/active-tab
             {:tabs tabs
              :sx #js {:py 0}}))
       ($ Fade
          {:in (boolean ad-variants-preview)
           ;; Remove the children from React tree when the preview isn't open.
           ;; This is important so e.g. the query used by the preview page
           ;; isn't active always.
           :unmountOnExit true}
          ($ ad-variant-preview-page {:onClose close-preview}))

       ($ Fade
          {:in (boolean creation)
           :unmountOnExit true}
          ($ ad-variant-creation-page))

       ($ campaign-tags-page (use-campaign-tags-page-props)))))
